import { Chip, Grid, InputAdornment, Skeleton, TextField, Typography, useMediaQuery } from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import SpecialistCard from "../../specialists/SpecialistCard";
import axios from "axios";
import he from 'he';

export default function Team(){

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('sm'));
    const [team, setTeam]=useState();
    const [types, setTypes]=useState();

    useEffect(()=>{
        //Fetch specialist types
        axios.get(
            WP_API_Settings.endpoint+
            'wp/v2/specialist_types'
        ).then((response)=>{
            setTypes(response.data);
        });
        //Fetch specialists
        axios.get(
            `${WP_API_Settings.endpoint}wp/v2/theme_specialists?acf_format=standard&orderby=menu_order&order=desc&per_page=20&page=1`
        ).then((response) => {
            console.log(response.data);
            setTeam(response.data);
        });
        
               
    },[]);

    const [activeType, setActiveType]=useState(0);
    const [search, setSearch]=useState('');

    function Filter({type}){
        return(
            <Chip
                label={he.decode(type.name)}
                onClick={()=>setActiveType(type.id)}
                sx={{
                    p: mobile ? '0.85rem 0.25rem' : '1.5rem 0.5rem',
                    m: mobile ? '0.35rem 0.25rem 0 0' : '0.5rem 0.5rem 0 0',
                    fontSize: mobile ? '0.75rem' : '1em',
                    fontWeight:600,
                    borderRadius:'2rem',
                    cursor: activeType===type.id? 'default' : 'pointer',
                    backgroundColor: activeType===type.id? '#005EAA' : '#EBEBEB',
                    color: activeType===type.id? '#fff' : '#000',
                    '&:hover':{
                        backgroundColor:'#005EAA',
                        color:'#fff'
                    }
                }}
            />
        );
    }

    return(
        <Container maxWidth='xl'
            id="team"
            sx={{
                margin:'4rem auto',
            }}
        >
            <Typography variant='h3'
                sx={{
                    mb:'2rem',
                    textAlign:'center',
                    fontSize:'1.6rem',
                    color:'#0C5EAA'
                }}
            >
                Some of our team
            </Typography>
            <Grid container spacing={4}>
                <Grid item xs={12} md={9}>
                    <Filter
                        type={{
                            name:'All',
                            id:0
                        }}
                    />
                    {types && types.map((type)=>{
                        return(
                            <Filter
                                key="type.id"
                                type={type}
                            />
                        )
                    })}
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        fullWidth
                        placeholder="Search team"
                        value={search}
                        onChange={e=>setSearch(e.target.value)}
                        InputProps={{
                            id:'search-field',
                            startAdornment:<InputAdornment position="start">
                                <SearchIcon
                                    sx={{
                                        color:theme=>theme.palette.green
                                    }}
                                />
                            </InputAdornment>
                        }}
                    />
                </Grid>
                {team ? (
                    [...team]
                    .sort((a, b) => {
                        const isBoardMemberA = a.specialist_types.includes(44);
                        const isBoardMemberB = b.specialist_types.includes(44);
                    
                        // if (isBoardMemberA && !isBoardMemberB) return -1;
                        // if (!isBoardMemberA && isBoardMemberB) return 1;

                        // if (!isBoardMemberA && !isBoardMemberB) {
                        //     const result = a.title.rendered.localeCompare(b.title.rendered);
                        //     return result;
                        // }
                    
                        // If neither or both are "board-members," sort alphabetically by title
                        // const result = b.menu_order - a.menu_order;
                        // return result;
                    })
                    .filter(
                      (member) =>
                        member.title.rendered.toLowerCase().includes(search.toLowerCase()) &&
                        (activeType === 0 || member.specialist_types.includes(activeType))
                    )
                    .map((member) => (
                      <Grid key={member.id} item xs={6} md={3}>
                        <SpecialistCard specialist={member} />
                      </Grid>
                    ))                  
                ) : (
                    Array(4)
                    .fill(0)
                    .map((_, index) => (
                        <Grid key={index} item xs={6} md={3}>
                        <Skeleton variant="rectangular" height={300} />
                        </Grid>
                    ))
                )}
            </Grid>
        </Container>
    );
}